module.exports = __webpack_public_path__ + "static/media/FEDE.1e60448a.png";